import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { selectActiveSidePanelModal } from "panels/content/side-panel/slice"
import { selectUploadsForSet } from "./PanoramaSlice"
import { selectActivatedFireId } from "features/map/control/selectors"

export const useProcessing = () => {
    const dispatch = useAppDispatch()
    const fireId = useAppSelector(selectActivatedFireId) || ""
    const activeSidePanelModalId = useAppSelector(selectActiveSidePanelModal())?.id || ""
    const uploads = useAppSelector(selectUploadsForSet(activeSidePanelModalId))

    const processCallback = () => {
        // return dispatch(
        //     createPanoramaJob({
        //         context: { flightId: activeSidePanelModalId },
        //     })
        // )
    }

    const canProcessPlugin = (baseRequirements: boolean) => {
        return baseRequirements
    }

    return {
        canProcessPlugin,
        processCallback,
        dependencies: [dispatch, uploads, fireId, activeSidePanelModalId],
    }
}
